




import { Component, Vue, Prop } from 'vue-property-decorator';

import axios from 'axios';

// Components

// Store and Router
import store from '@/store';
import router from '@/router';

@Component({
	name: 'signout',
	components: {},
})
export default class Signout extends Vue {
	constructor() {
		super();
	}

	private async created() {
		await this.$Amplify.Auth.signOut();
		this.$store.dispatch('Auth/signout');
	}
}
